import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { FlowService } from 'src/app/services/flow.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { handleApiError } from 'src/app/utils/error';

@Component({
  selector: 'app-personal-contact',
  templateUrl: './personal-contact.component.html',
  styleUrls: ['./personal-contact.component.scss']
})

export class PersonalContactComponent implements OnInit, OnDestroy {
  applicationId!: number;
  personalContactForm!: FormGroup;
  error!: string;
  subs: Array<Subscription> = [];
  requestPending = false;
  @Input() isSummary!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    private applicationsApiService: ApplicationsApiService,
    public flowService: FlowService,
    protected trackingService: TrackingService
  ) { }

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;

    this.personalContactForm = this.formBuilder.group({
      personalContact: [this.applicationService.personalContact],
    });

    this.subs.push(
      this.personalContact.valueChanges
        .pipe(debounceTime(200))
        .subscribe((v: boolean) => {
          this.requestPending = true;
          if (v) {
            this.applicationService.personalContact = true;
          } else {
            this.applicationService.personalContact = false;
          }
          this.applicationsApiService
            .updateApplication({ 
              personalContact: this.applicationService.personalContact,
              applicationId: this.applicationId
            })
            .pipe(take(1))
            .subscribe(
              () => {
                this.error = '';
                this.trackFields('personalContact');
              },
              (error: any) => handleApiError(error, this.translateService),
              () => this.requestPending = false
            );
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }

  handleContinueButtonClick(): void {
    if (!this.personalContactForm.valid) {
      return;
    }
    this.flowService.nextScreen();
  }

  handleBackButtonClick(): void {
    this.flowService.previousScreen();
  }

  get personalContact(): FormControl {
    return this.personalContactForm.get('personalContact') as FormControl;
  }
}
